// @ts-nocheck

import { type MyMatchActionType, MyMatchActionTypes } from '../types/actions/mymatch';

type MyMatchActionBody = {
  type: MyMatchActionType;
  payload?: unknown;
};
export type MyMatchActionHooks = {
  onSuccess?: (result: unknown) => void;
  onError?: (error: unknown) => void;
  onFinally?: () => void;
};

type ToggleMatchViewModeSwitchParams = { matchId: number };
export const toggleMatchViewModeSwitch = (
  { matchId }: ToggleMatchViewModeSwitchParams,
  hooks: MyMatchActionHooks,
): MyMatchActionBody => ({
  type: MyMatchActionTypes.TOGGLE_MATCH_VIEW_MODE_SWITCH,
  payload: {
    matchId,
  },
  hooks,
});

type GetFutureOddsParams = {
  matchId: number;
  triggerLoading?: boolean;
  preventCallOutsideMatchRoute?: boolean;
  shouldHideOddUpdateIndicators?: boolean;
  forceWithLease?: boolean;
};
export const getFutureOdds = (
  {
    matchId,
    triggerLoading = true,
    preventCallOutsideMatchRoute = true,
    shouldHideOddUpdateIndicators = false,
    forceWithLease = false,
  }: GetFutureOddsParams,
  hooks: MyMatchActionHooks,
): MyMatchActionBody => ({
  type: MyMatchActionTypes.GET_FUTURE_ODDS,
  payload: {
    matchId,
    triggerLoading,
    preventCallOutsideMatchRoute,
    shouldHideOddUpdateIndicators,
    forceWithLease,
  },
  hooks,
});

type GetOddsParams = { matchId: number; outcomes?: Array<{ betId: number; outcomeId: number }> };
export const getOdds = ({ matchId, outcomes }: GetOddsParams, hooks: MyMatchActionHooks) => ({
  type: MyMatchActionTypes.GET_ODDS,
  payload: {
    matchId,
    outcomes,
  },
  hooks,
});

export const requestMyMatchAddWithMerge = ({
  oddId,
  matchId,
  betId,
  sourceElementUuid,
  isFromLineUp,
  isFromMultichoice,
}) => ({
  type: MyMatchActionTypes.REQUEST_ADD_WITH_MERGE,
  payload: {
    oddId,
    matchId,
    betId,
    sourceElementUuid,
    isFromLineUp,
    isFromMultichoice,
  },
});

export const requestMyMatchDeletionWithMerge = ({ oddId, matchId }) => ({
  type: MyMatchActionTypes.REQUEST_DELETION_WITH_MERGE,
  payload: {
    oddId,
    matchId,
  },
});

export const requestMyMatchOutcomeInjection = ({ oddId, matchId, betId, sourceElementUuid, isFromMultichoice }) => ({
  type: MyMatchActionTypes.REQUEST_OUTCOME_INJECTION,
  payload: {
    oddId,
    matchId,
    betId,
    sourceElementUuid,
    isFromMultichoice,
  },
});

export const requestMyMatchOutcomeDeletion = ({
  myMatchBasketItemId,
  selectionItemOddId,
  isFromMultichoice,
  itemFoundInOutcomeIds,
}) => ({
  type: MyMatchActionTypes.REQUEST_OUTCOME_DELETION,
  payload: {
    myMatchBasketItemId,
    selectionItemOddId,
    isFromMultichoice,
    itemFoundInOutcomeIds,
  },
});

export const requestMyMatchMerge = ({ matchId }, hooks: MyMatchActionHooks) => ({
  type: MyMatchActionTypes.REQUEST_MERGE,
  payload: {
    matchId,
  },
  hooks,
});

export const requestMyMatchSplit = ({ oddId }, hooks: MyMatchActionHooks) => ({
  type: MyMatchActionTypes.REQUEST_SPLIT,
  payload: {
    oddId,
  },
  hooks,
});

export const requestToggleMyMatchMode = ({ matchId }) => ({
  type: MyMatchActionTypes.REQUEST_TOGGLE_MY_MATCH_MODE,
  payload: {
    matchId,
  },
});

export const setMyMatchMode = ({ matchId }) => ({
  type: MyMatchActionTypes.SET_MY_MATCH_MODE,
  payload: {
    matchId,
  },
});

export const unsetMyMatchMode = ({ matchId }) => ({
  type: MyMatchActionTypes.UNSET_MY_MATCH_MODE,
  payload: {
    matchId,
  },
});

export const receivedGetFutureOddsResultEntities = ({ bets, outcomes }, matchId) => ({
  type: MyMatchActionTypes.RECEIVED_GET_FUTURE_ODDS_ENTITIES,
  payload: {
    matchId,
    bets,
    outcomes,
  },
});

export const receivedGetFutureOddsEntitiesUpdates = ({ bets, outcomes }) => ({
  type: MyMatchActionTypes.RECEIVED_GET_FUTURE_ODDS_ENTITIES_UPDATES,
  payload: {
    bets,
    outcomes,
  },
});

export const myMatchMerge = ({ itemIdsToRemove, matchId, selectionItems, value, sourceElementUuid, oddId }) => ({
  type: MyMatchActionTypes.MERGE,
  payload: {
    itemIdsToRemove,
    matchId,
    selectionItems,
    value,
    sourceElementUuid,
    oddId,
  },
});

export const myMatchSplit = ({ matchId, itemIdToRemove, splitedItems, sourceElementUuid, oddId }) => ({
  type: MyMatchActionTypes.SPLIT,
  payload: {
    matchId,
    itemIdToRemove,
    splitedItems,
    sourceElementUuid,
    oddId,
  },
});

export const injectTMMIntoBasket = ({ matchId, outcomes, value }) => ({
  type: MyMatchActionTypes.INJECT_TOP_MY_MATCH_INTO_BASKET,
  payload: {
    matchId,
    outcomes,
    value,
  },
});

export const clearMyMatchModeMatchIds = () => ({
  type: MyMatchActionTypes.CLEAR_MY_MATCH_MODE_MATCH_IDS,
});

export const removeMultichoiceBetSelection = ({ betId, matchId }) => ({
  type: MyMatchActionTypes.REMOVE_MULTICHOICE_BET_SELECTION,
  payload: {
    betId,
    matchId,
  },
});
